import React, { useEffect, useState } from 'react';
import styles from './AlumniPage.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import ApplicantsTab from '../../Atoms/Tabs/ApplicantsTab';
import successStoriesIcon from '../../../assets/Imagess/success-stories-icon.svg';
import plus from '../../../assets/Imagess/plusvector.svg';
import saveIcon from '../../../assets/Imagess/save-icon.svg';
import {
  useFetchAlumni,
  useFetchAlumniSuccessStories,
  useFetchAmbassadors,
  useFetchGraduationBatch,
} from '../../../Hooks/Alumni';
import AlumniTopHeader from '../../Molecules/Alumni/AlumniTopHeader';
import { useMutation } from 'react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL, securityHeaders } from '../../../Constants';
import AlumniCard from '../../Molecules/Council/AlumniCard';
import { useFetchEvents } from '../../../Hooks/News';
import EventsActivityHeader from '../../Molecules/NewsAndEvents/EventsActivityHeader';
import { useToast } from '../../Molecules/Custom/CustomToaster/Toast';
import Loader from '../../Molecules/Loader/Loader';
import { debounce, isEmpty } from 'lodash';
import NoDataComponent from '../../Molecules/Custom/NoDataComponent/NoDataComponent';

const AlumniPage = () => {
  const [search, setSearch] = useState('');
  const { active } = useParams();
  const [selected, setSelected] = useState('success-stories');
  const navigate = useNavigate();
  const [selectedActivity, setSelectedActivity] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [usersPageSize, setUsersPageSize] = useState(10);
  const [usersPage, setUsersPage] = useState(1);
  const [selectedUser, setSelectedUser] = useState({});
  const [graduateBatch, setGraduateBatch] = useState('');
  const [upcomingBatch, setUpcomingBatch] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [eventsType, setEventsType] = useState('events');
  const customizedToast = useToast();
  const { data: batchData, refetch: refetchBatchData } =
    useFetchGraduationBatch();
  const {
    data: events,
    refetch: refetchEvents,
    isLoading,
  } = useFetchEvents({
    pageSize: pageSize,
    pageNumber: page,
    year: '',
    selectedActivity: selectedActivity,
    searchKey: search,
  });

  const itemsPerPage = events?.data?.pageSize;
  const totalItems = events?.data?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const {
    data: users,
    refetch: refetchUsers,
    isLoading: isUsersLoading,
  } = useFetchAlumni({
    pageSize: usersPageSize,
    pageNumber: usersPage,
    searchKey: search,
  });

  useEffect(() => {
    setGraduateBatch(batchData?.data?.graduationBatchCount);
    setUpcomingBatch(batchData?.data?.batchNumber);
  }, [batchData]);

  useEffect(() => {
    refetchEvents();
  }, [page, pageSize, selectedActivity, search]);

  const tableHeader = [
    {
      name: 'Name',
      originalName: 'alumniName_EN',
      colSpan: 2,
    },
    {
      name: 'Program',
      originalName: 'degreeName_EN',
      colSpan: 1,
    },
    {
      name: 'Date of Graduation',
      originalName: 'graduationDate',
      colSpan: 1,
    },
    {
      name: 'Academic Year',
      originalName: 'academicYear',
      colSpan: 1,
    },
  ];

  const tabs = [
    // { index: 0, name: "batch", text: "Batch", icon: batchIcon },
    // {
    //   index: 1,
    //   name: "students",
    //   text: "Students",
    //   icon: studentsIcon,
    // },
    {
      index: 2,
      name: 'success-stories',
      text: 'Success Stories',
      icon: successStoriesIcon,
    },
    // {
    //   index: 3,
    //   name: "ambassadors",
    //   text: "Ambassadors",
    //   icon: ambassadorsIcon,
    // },
  ];

  useEffect(() => {
    refetchUsers();
  }, [usersPage, usersPageSize]);

  const {
    data: successStories,
    refetch: refetchStories,
    isLoading: isLoadingStories,
  } = useFetchAlumniSuccessStories(search);

  const {
    data: ambassadors,
    refetch: refetchAmbassadors,
    isLoading: isLoadingAmbassadors,
  } = useFetchAmbassadors(search);

  useEffect(() => {
    if (!isEmpty(search)) {
      handleSearch();
    }
  }, [search]);

  const handleSearch = debounce(() => {
    if ('students' === selected) {
      refetchUsers();
    }
    if ('success-stories' === selected) {
      refetchStories();
    }
    if ('ambassadors' === selected) {
      refetchAmbassadors();
    }
  }, 300);

  useEffect(() => {
    setSelected(active);
  }, [active]);

  const updateBatch = useMutation({
    mutationFn: (fields) => {
      return axios.post(
        API_URL +
          `/api/Alumni/PostGraduationBatch/${graduateBatch}/${upcomingBatch}`,
        {},
        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: (data) => {
      customizedToast.open('تم تحديث الدفعات!');
      refetchBatchData();
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  useEffect(() => {
    if ('success-stories' === selected) {
      refetchStories();
    }
    if ('ambassadors' === selected) {
      refetchAmbassadors();
    }
    if ('batch' === selected) {
      refetchBatchData();
    }
    if ('event' === selected) {
      refetchEvents();
    }
  }, [selected]);

  const handleNavigate = (e) => {
    e.preventDefault();
    if ('batch' === selected) {
      updateBatch.mutate();
    }
    if ('students' === selected) {
      navigate('/home/add-student-alumni');
    }
    if ('success-stories' === selected) {
      navigate('/home/add-success-story');
    }
    if ('ambassadors' === selected) {
      navigate('/home/add-ambassador');
    }
  };

  return (
    <div>
      <AlumniTopHeader
        search={search}
        setSearch={setSearch}
        handleNewClick={handleNavigate}
        buttonTitle={
          'batch' === selected
            ? 'تحديث'
            : 'students' === selected
            ? 'إضافة طالب جديد'
            : 'success-stories' === selected
            ? 'إضافة قصة جديدة'
            : 'ambassadors' === selected
            ? 'إضافة سفير'
            : 'إضافة حدث'
        }
        icon={'batch' === selected ? saveIcon : plus}
        selected={selected}
      />
      <div className={styles['container']}>
        {'events' === selected && (
          <EventsActivityHeader
            eventsType={eventsType}
            setEventsType={setEventsType}
            selectedActivity={selectedActivity}
            setSelectedActivity={setSelectedActivity}
          />
        )}
        <div className={styles['table-container']}>
          {isLoadingStories ? (
            <Loader />
          ) : (
            <>
              {successStories?.data?.length > 0 ? (
                <div className={styles['major-box-grid']}>
                  {successStories?.data?.map((x) => (
                    <AlumniCard
                      data={x}
                      refetch={refetchStories}
                      selected={selected}
                      key={x?.alumniSuccessStoryId}
                      type="success-story"
                    />
                  ))}
                </div>
              ) : (
                <NoDataComponent />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlumniPage;
